import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory } from 'react-router-dom';
import { mostrarPostosAtendimento } from '../../Home/Home';
import indicativoNascimentoPostoAtendimento from '../../../assets/img/indicativo-nascimento-cras.svg';
import styles from '../ComparecaAoCras/ComparecaAoCras.module.css';

interface Props {
  onFechar: () => void;
}

const ComparecaAoCrasInclusao: React.FC<Props> = ({ onFechar }) => {
  const history = useHistory();

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img
          className={styles.imagem}
          src={indicativoNascimentoPostoAtendimento}
          alt="Posto de atendimento"
        />
      </div>
      <div className={styles.conteudo}>
        <p className={styles.textoPrincipal}>
          Compareça ao CRAS ou posto de atendimento do Cadastro Único para realizar a inclusão do HEITOR na sua família.
        </p>
        <p className={styles.textoPrincipal}>
          No atendimento presencial podemos oferecer atendimentos e políticas mais adequadas.
        </p>
        <p className={styles.textoSecundario}>
          Você pode buscar onde ficam os postos de atendimento mais próximos de você na opção{' '}
          <span className={styles.link} onClick={() => mostrarPostosAtendimento(history)}>
            Postos de Atendimento
          </span>
          .
        </p>
        <BrButton className={styles.botaoFechar} onClick={onFechar}>
          Fechar
        </BrButton>
      </div>
    </div>
  );
};

export default ComparecaAoCrasInclusao;
